let clamp = (value, min, max) => {
  value = value|0;
  if (value > max)
    return max;
  if (value < min)
    return min;
  return value;
}

export default class DataBlock {
  constructor() {
    this.chunks = [];
    this.CHUNK_LENGTH = 4096;

    this.chunkIndex = -1;
    this.chunkOffset = 0;

    this.length = 0;
  }

  __put(value) {
    if (this.chunkIndex < 0 || this.chunkOffset == this.chunks[this.chunkIndex].length) {
      this.chunks.push(new Uint8ClampedArray(this.CHUNK_LENGTH));
      this.chunkIndex = this.chunks.length - 1;
      this.chunkOffset = 0;
    }

    this.chunks[this.chunkIndex][this.chunkOffset] = value|0;
    this.chunkOffset += 1;
    this.length += 1;
  }

  put2() {
    for (let i = 0; i < arguments.length; i++) {
      let value = arguments[i];
      value = clamp(value, 0x0000, 0xFFFF);
      this.__put(value >> 8);
      this.__put(value % 0x100);
    }
  }

  put4() {
    for (let i = 0; i < arguments.length; i++) {
      let value = arguments[i];
      value = clamp(value, 0x0000, 0xFFFFFFFF);
      this.__put((value >> 24));
      this.__put((value >> 16) % 0x100);
      this.__put((value >> 8) % 0x100);
      this.__put(value % 0x100);
    }
  }

  putDouble() {
    let buf = new ArrayBuffer(8);
    let arr = new Float64Array(buf);
    for (let i = 0; i < arguments.length; i++) {
      let value = arguments[i];
      arr[0] = value;
      this.putArray(Array.from(new Uint8Array(buf)).reverse());
    }
  }

  putSignature(value) {
    for (let i = 0; i < value.length; i++) {
      this.__put(value.charCodeAt(i) % 0x100);
    }
  }

  putUtf16(value) {
    for (let i = 0; i < value.length; i++) {
      this.put2(value.charCodeAt(i));
    }
  }

  putString(value) {
    let enc = new TextEncoder();
    value = enc.encode(value);
    this.put4(value.length);
    this.put(value);
  }

  putArray(value) {
    for (let i = 0; i < value.length; i++) {
      this.__put(value[i]);
    }
  }

  putBlock(value) {
    if (value.length == 0)
      return;

    // ниже - грязный хак, в результате которого чанки будут иметь
    // не строго одинаковые размеры
    // (да и вообще весь этот код - сплошной хак)
    if (this.chunkIndex >= 0 && this.chunkOffset < this.chunks[this.chunkIndex].length) {
      this.chunks[this.chunkIndex] = this.chunks[this.chunkIndex].slice(0, this.chunkOffset);
    }

    this.chunks = this.chunks.concat(value.chunks);
    this.chunkIndex = this.chunks.length - 1;
    this.chunkOffset = value.chunkOffset;
    this.length += value.length;
  }

  putHex(value) {
    for(let i = 0; i < value.length - 1; i += 2) {
      this.__put(parseInt(value.substr(i, 2), 16));
    }
  }

  putPadding(paddingSize, paddedLength, paddingValue) {
    if (paddingValue === undefined) paddingValue = 0;
    if (paddedLength === undefined) paddedLength = this.length;
    if (paddedLength % paddingSize == 0) return;
    for (let i = 0; i < paddingSize - (paddedLength % paddingSize); i++) {
      this.__put(paddingValue);
    }
  }

  putPascalString(str, padding) {
    if (padding === undefined) padding = 2;
    this.put(str.length, str);
    this.putPadding(padding, str.length + 1);
  }

  put() {
    for (let i = 0; i < arguments.length; i++) {
      let value = arguments[i];

      if (typeof value == 'string') {
        this.putSignature(value);
      } else if (Number.isInteger(value)) {
        this.__put(value);
      } else if (Array.isArray(value) || ((typeof value == 'object') && ('BYTES_PER_ELEMENT' in value))) {
        this.putArray(value);
      } else if (value instanceof DataBlock) {
        this.putBlock(value);
      }
    }
  }

  getData() {
    if (this.chunkIndex >= 0) {
      this.chunks[this.chunkIndex] = this.chunks[this.chunkIndex].slice(0, this.chunkOffset);
    }

    let data = new Uint8Array(this.length);
    let offset = 0;
    for (let i = 0; i < this.chunks.length; i++) {
      data.set(this.chunks[i], offset);
      offset += this.chunks[i].length;
    }
    return data;
  }
}
